import get from 'lodash/get';
import PropTypes from 'prop-types';
import {useState} from 'react';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import EditIcon from '@mui/icons-material/Edit';
import IconButton from '@mui/material/IconButton';

import {useUpdateProviderMutation} from '../../redux/services/providerApi';
import CustomNumberField from '../common/CustomNumberField';

const handleSave = ({provider, value, updateProvider, setIsOpen, postSave}) => async () => {
  const res = await updateProvider({
    id: provider.id,
    body: {weekly_session_goal: parseInt(value, 10)}
  });
  if (res.data) setIsOpen(false);
  if (postSave) postSave();
};

const GoalEditor = props => {
  const {provider} = props;
  const [isOpen, setIsOpen] = useState(false);
  const [value, setValue] = useState(get(provider, 'weekly_session_goal'));
  const [updateProvider, response] = useUpdateProviderMutation();
  return (
    <>
      <IconButton
        color='primary'
        onClick={() => setIsOpen(true)}
      >
        <EditIcon sx={{ fontSize: 18 }}/>
      </IconButton>
      <Dialog open={isOpen} onClose={() => setIsOpen(false)}>
        <DialogContent>
          <CustomNumberField
            label='Weekly Session Goal'
            defaultValue={get(provider, 'weekly_session_goal')}
            onChange={e => setValue(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button
            disabled={response.isLoading}
            onClick={handleSave({
              provider,
              value,
              updateProvider,
              setIsOpen,
              postSave: props.postSave,
            })}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

GoalEditor.propTypes = {
  provider: PropTypes.object,
  postSave: PropTypes.func,
};

export default GoalEditor;
